(function () {
	'use strict';

	angular
		.module('expo-cupom-digital', [
			'ngSanitize',
			'ui.router',
			'ngMask',
			'angularValidator',
			'19degrees.ngSweetAlert2',
			'ui.select',
			'timer',
			'ui.utils.masks',
			'ui.swiper',
			'smart-table',

			'expo-cupom-digital.configs',
			'expo-cupom-digital.constants',
			'expo-cupom-digital.directives',
			'expo-cupom-digital.routes',
			'expo-cupom-digital.services'
		])
		.run(run);

	/** @ngInject */
	function run(HelperService, $trace, $transitions, $rootScope, $state, $window) {
		$trace.enable(1, 5);

		HelperService.handleOnRun();

		$transitions.onEnter({}, $transition => {
			return HelperService.handleStateChangeStart($transition);

		});

		$transitions.onSuccess({}, $transition => {
			$rootScope.pageTitle = `${$transition.to().title} - Expo D. Pedro`;
			$rootScope.currentState = $state.current.name;
		});

		$transitions.onSuccess({}, $transition => {
			$rootScope.pageTitle = `${$transition.to().title} - Expo D. Pedro`;
			$rootScope.currentState = $state.current.name;

			HelperService.handleStateChangeSuccess($transition);
		});

		$transitions.onError({}, ($transition, error) => {
			HelperService.handleStateChangeError(error);
		});

		$window.onload = () => {
			HelperService.handleViewContentLoaded();
		}

		$rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);
	}
})();